"use client";

import { useEffect } from "react";

import { resetToMain } from "@repo/store";

import { getTabSessionId } from "@repo/ui/lib/tabSessionId";
import { useZonePathname } from "@repo/ui/navigation";

import { useAppDispatch } from "@repo/store/hooks";

import { resetBooking } from "@/app/booking/actions/resetBooking";

const HOME_BOOKING_RESET_KEY_PREFIX = "home_booking_reset_done";

function getResetStorageKey(tabSessionId: string) {
  return `${HOME_BOOKING_RESET_KEY_PREFIX}:${tabSessionId}`;
}

export default function HomeBookingResetGuard() {
  const dispatch = useAppDispatch();
  const pathname = useZonePathname(); // locale- and zone-stripped: "/cl/es" must read as the home path "/"

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const tabSessionId = getTabSessionId();
    if (!tabSessionId) {
      return;
    }

    const storageKey = getResetStorageKey(tabSessionId);

    if (pathname !== "/") {
      sessionStorage.removeItem(storageKey);
      return;
    }

    if (sessionStorage.getItem(storageKey) === "true") {
      return;
    }

    sessionStorage.setItem(storageKey, "true");
    dispatch(resetToMain());

    void (async () => {
      try {
        await resetBooking(tabSessionId);
      } catch (error) {
        console.warn("[HomeBookingResetGuard] Failed to reset booking on home:", error);
      }
    })();
  }, [dispatch, pathname]);

  return null;
}
